import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, nextTick, ComponentPublicInstance } from 'vue';
  import { OptionSetForm, OptionValue, validate } from '@/entities/optionSet';
  import { useValidation, useTask } from '@/ui/concerns';
  import { create, update, OptionSetDetail } from '@/services/api/resources/optionSet';
  import { ApiResponse } from '@/services/api/response/response';
  import { Modal } from '@/ui/components/Modal';
  import { PageSubtitle, ApiErrorMessage } from '@/ui/components';
  import { InputField, CheckboxField } from '@/ui/components/form';
  import { Button } from '@/ui/components/Button';
  import { Icon } from '@/ui/components/icon/Icon';
  import { DROPDOWN_RESPONSE_SET_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import { Versioned } from '@/services/api';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownResponseSetModal',
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    optionSet: {
      type: Object as () => Versioned<OptionSetDetail> | null,
      default: null,
    },
    optionSetId: {
      type: Number,
      default: null,
    },
    allowMulti: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'saved', 'update:allowMulti'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const record = ref<OptionSetForm>({
    name: '',
    optionValues: [
      { label: '', value: null, isActive: true },
    ],
  });

  const optionInputRefs: Record<number, ComponentPublicInstance | Element | null> = {};

  const setOptionRef = (el: Element | ComponentPublicInstance | null, index: number) => {
    if (el) {
      optionInputRefs[index] = el;
    }
  };

  const performSave = () => {
    if (props.optionSet && props.optionSetId) {
      return update(props.optionSetId, { data: record.value, version: props.optionSet.version });
    }

    return create(record.value);
  };

  const handleSaveSuccess = (response: { id?: number } | ApiResponse) => {
    const responseId = 'id' in response ? response.id : undefined;
    const optionSetId = props.optionSetId || responseId;
    const savedOptionSet = {
      id: optionSetId,
      name: record.value.name,
      optionValues: record.value.optionValues,
    };
    emit('saved', savedOptionSet, props.allowMulti || false);
    emit('close');
  };

  const saveTask = useTask(performSave, handleSaveSuccess);

  const {
    validationErrors,
    hasNoValidationErrors,
    showValidationErrors,
  } = useValidation(validate, record, saveTask.state);

  const updateName = (value: string) => {
    record.value.name = value;
  };

  const updateOptionLabel = (index: number, value: string) => {
    record.value.optionValues[index].label = value;
  };

  const addOption = () => {
    record.value.optionValues.push({
      label: '',
      value: null,
      isActive: true,
    });
  };

  const addOptionAndFocus = () => {
    const currentLength = record.value.optionValues.length;
    addOption();

    nextTick(() => {
      const newOptionInput = optionInputRefs[currentLength];
      const element = (newOptionInput && '$el' in newOptionInput) ? newOptionInput.$el : newOptionInput;
      element?.querySelector('input')?.focus();
    });
  };

  const removeOption = (index: number) => {
    if (record.value.optionValues.length > 1) {
      record.value.optionValues.splice(index, 1);
    }
  };

  const handleSave = () => {
    record.value.optionValues = record.value.optionValues.filter(ov => ov.label && ov.label.trim() !== '');

    showValidationErrors.value = true;
    if (hasNoValidationErrors.value) {
      saveTask.run();
    }
  };

  const handleAllowMulti = (value: boolean) => {
    emit('update:allowMulti', value);
  };

  // Watch for changes to optionSet to initialize/reset the form
  watch(() => props.optionSet, optionSet => {
    if (optionSet && optionSet.data) {
      const data = optionSet.data.data || optionSet.data;
      record.value = {
        name: data.name,
        optionValues: data.optionValues.map((ov: OptionValue) => ({
          id: ov.id,
          label: ov.label,
          value: ov.value,
          isActive: ov.isActive,
        })),
      };
    }
  }, { immediate: true });

  // Reset form when modal closes or when opening for create
  watch(() => props.active, active => {
    if (!active) {
      record.value = {
        name: '',
        optionValues: [
          { label: '', value: null, isActive: true },
        ],
      };
    }
  });

return { __sfc: true,props, emit, record, optionInputRefs, setOptionRef, performSave, handleSaveSuccess, saveTask, validationErrors, hasNoValidationErrors, showValidationErrors, updateName, updateOptionLabel, addOption, addOptionAndFocus, removeOption, handleSave, handleAllowMulti, Modal, PageSubtitle, ApiErrorMessage, InputField, CheckboxField, Button, Icon, DROPDOWN_RESPONSE_SET_MODAL_WIDTH }
}

})